module.exports = __webpack_public_path__ + "img/transfer_hub_(in_out_hub).e52c601a.svg";